"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrayContent = exports.TrayItem = exports.xsTrayItemHeight = exports.trayItemHeight = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const shared_1 = require("../../shared");
const atoms_1 = require("../atoms");
exports.trayItemHeight = 65;
exports.xsTrayItemHeight = 48;
const TrayMenuToggle = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return react_1.default.createElement("div", Object.assign({}, props), children);
};
const UnstyledTrayItem = (_a) => {
    var { isMenuToggle, toggleMenu, link, locale, children } = _a, props = __rest(_a, ["isMenuToggle", "toggleMenu", "link", "locale", "children"]);
    const closeMenus = (0, shared_1.useCloseAllMenus)();
    if (isMenuToggle) {
        return (react_1.default.createElement(TrayMenuToggle, Object.assign({ onClick: toggleMenu, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick }, props), children));
    }
    if (!link) {
        return null;
    }
    return (react_1.default.createElement(atoms_1.NavLink, Object.assign({ link: link, locale: locale !== null && locale !== void 0 ? locale : "en-US", onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, onClick: (ev) => {
            closeMenus();
            if (props.onClick)
                props.onClick(ev);
        } }, props), children));
};
exports.TrayItem = (0, styled_components_1.default)(UnstyledTrayItem) `
	color: ${(p) => p.theme.palette.text.primary};
	padding: 0;
	font-size: 12px;
	letter-spacing: 1.05px;
	line-height: 16px;
	display: inline-block;
	text-transform: uppercase;
	text-decoration: none;
	text-align: left;
	height: ${exports.trayItemHeight}px;
	${(p) => p.theme.breakpoints.down("xs")} {
		height: ${exports.xsTrayItemHeight}px;
	}
	width: 268px;
	display: flex;
	align-items: center;
	border-bottom: 1px solid ${(p) => p.theme.palette.border};
	position: relative;
	&:last-child {
		border-bottom: none;
	}
	white-space: nowrap;

	.tray-item-inner {
		position: relative;
		width: 100%;
		padding: 0px 24px;
		overflow: hidden;

		> .arrow-wrap {
			right: 24px;
		}

		.tray-item-title {
			padding: 12px 16px 12px 0;
		}
	}

	&:hover {
		background: ${(p) => p.theme.palette.background.paper};
		.tray-item-inner > .arrow-wrap {
			transform: translate3d(0, 0, 0) translateX(4px);
		}
	}

	&.navlink {
		display: flex;
		justify-content: center;
	}
`;
const Styled = styled_components_1.default.div `
	position: absolute;
	left: ${(p) => (p.menuOpen ? 0 : "100%")};
	overflow: hidden;
	top: 0;
	bottom: 0;
	width: 100%;
	z-index: 9002;
	background: ${(p) => p.theme.palette.background.default};
	transition: left 0.2s ease-in-out;
	cursor: default;
	display: flex;
	flex-direction: column;
	height: fit-content;
	min-height: 100%;
	max-height: ${(p) => (p.innerHeight ? `calc(${p.innerHeight}px - ${p.theme.navHeight}px)` : "100vh")};
`;
exports.TrayContent = react_1.default.forwardRef(({ className, menuOpen, children, topOffset = 0 }, ref) => {
    const [height, setHeight] = (0, react_1.useState)(0);
    const checkHeight = (0, react_1.useCallback)(() => {
        if (window_or_global_1.default.innerHeight) {
            const newHeight = window_or_global_1.default.innerHeight - topOffset;
            if (newHeight && !Number.isNaN(newHeight) && newHeight !== height) {
                setHeight(newHeight);
            }
        }
    }, [height, setHeight, topOffset]);
    const throttleCheck = (0, lodash_throttle_1.default)(checkHeight, 250, { leading: false });
    (0, react_1.useEffect)(() => {
        checkHeight();
        window_or_global_1.default.addEventListener("resize", throttleCheck);
        return () => {
            throttleCheck.cancel();
            window_or_global_1.default.removeEventListener("resize", throttleCheck);
        };
    }, [checkHeight, throttleCheck]);
    return (react_1.default.createElement(Styled, { ref: ref, className: `tray-content ${className || ""}`, menuOpen: menuOpen, innerHeight: height }, children));
});
exports.TrayContent.displayName = "TrayContent";
//# sourceMappingURL=TrayItem.js.map